import React from 'react';
import connect from 'react-redux/es/connect/connect';
import PropTypes from 'prop-types';
import { Modal, Button } from 'semantic-ui-react';
import { history } from '../../helpers/index';
import { projectActions } from '../../actions';
import Strings from '../../common/Strings';
import './ProjectDialog.css';
import Constant from '../../common/Constant';

const moment = require('moment');

class ProjectDialog extends React.Component {
  onClickContinue = () => {
    const project = { ...this.props.project };
    if (project.status === 'active') {
      project.status = 'closed';
      project.closedAt = moment().format(Constant.DATE_FORMAT_LONG);
      project.teamMembers = project.teamMembers.map(t => ({
        ...t,
        status: 'disconnected',
      }));
    } else if (project.status === 'closed') {
      project.status = 'active';
      project.closedAt = '';
    }

    this.props.dispatch(projectActions.updateProject(project));
  };

  render() {
    const { isCreatingOrUpdatingProject, project } = this.props;
    const isActive = project.status === 'active';
    const title = isActive
      ? Strings.PROJECT_DETAILS.closeProjectDialogTitle
      : Strings.PROJECT_DETAILS.reopenProjectDialogTitle;
    const header = isActive
      ? Strings.PROJECT_DETAILS.closeProjectDialogHeader
      : Strings.PROJECT_DETAILS.reopenProjectDialogHeader;
    const body = isActive
      ? Strings.PROJECT_DETAILS.closeProjectDialogBody
      : Strings.PROJECT_DETAILS.reopenProjectDialogBody;
    return (
      <Modal
        centered
        open
        size="tiny"
        closeIcon={!isCreatingOrUpdatingProject}
        onClose={() => {
          if (!isCreatingOrUpdatingProject) history.goBack();
        }}
      >
        <div className="close-project-modal-root">
          <div
            className="close-project-color-container"
            style={{ backgroundColor: project.color }}
          >
            <p className="close-project-title">{title}</p>
          </div>
          <div className="close-project-content">
            <p className="close-project-header">{header}</p>
            <p className="close-project-body">{body}</p>
            <div style={{ display: 'flex' }}>
              {!isCreatingOrUpdatingProject && (
                <Button
                  id="project-cancel-button"
                  className="common-grey-button"
                  onClick={() => history.goBack()}
                >
                  {Strings.COMMON.cancel}
                </Button>
              )}
              {!isCreatingOrUpdatingProject && <div style={{ width: 10 }} />}
              <Button
                id="project-continue-button"
                className="common-green-button"
                onClick={this.onClickContinue}
                loading={isCreatingOrUpdatingProject}
              >
                {Strings.COMMON.continue}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

ProjectDialog.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isCreatingOrUpdatingProject: PropTypes.bool.isRequired,
  project: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    currencyCode: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  isCreatingOrUpdatingProject: state.uiState.isCreatingOrUpdatingProject,
});

export default connect(mapStateToProps)(ProjectDialog);



// WEBPACK FOOTER //
// ./src/components/dialog/ProjectDialog.js